/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 12/7/2021
 * @Example
 */

export const types = {
    W05F0010_LOAD_FORM: 'W05F0010_LOAD_FORM',
}

export function loadForm(params, cb) {
    return {
        type: types.W05F0010_LOAD_FORM,
        params,
        cb
    }
}